import { createContext, use } from "react";

/**
 * Indent / de-indent a still-unsaved (temporary, negative-id) task while its title
 * is being typed. Because the task isn't persisted yet, these operate on the query
 * cache directly (setting `parentTask`) instead of the tRPC mutation — the parent is
 * then sent along when the task is finally inserted.
 */
export type NewTaskIndentContextValue = {
    indent: (taskId: number) => void;
    outdent: (taskId: number) => void;
};

const NewTaskIndentContext = createContext<NewTaskIndentContextValue | null>(null);

export const NewTaskIndentProvider = NewTaskIndentContext.Provider;

export function useNewTaskIndent(): NewTaskIndentContextValue | null {
    return use(NewTaskIndentContext);
}
